const orcaBlue = {
  main: "#1b223a",
  light: "#5b627a",
  dark: "#0b122a",
};

export { orcaBlue };
